// Base layout elements schema from vertical base
import { baseLayoutElementsSchema } from 'ctm-vertical-base';

// layout elements
import bodyResults from './body_results.json';
import bodyMoreInfo from './body_more_info.json';
import bodyCallOptions from './body_call_options.json';
import header from './header.json';


// Main mapping
import layoutMappingSchema from './main.json';


const layoutElementsSchema = {
    ...baseLayoutElementsSchema,
    ...bodyResults,
    ...bodyMoreInfo,
    ...bodyCallOptions,
    ...header
};

export default { layoutMappingSchema, layoutElementsSchema };
